/* ============================================================================
   McDuffy Quiz v2 — BOOT (entry glue)
   ----------------------------------------------------------------------------
   Parses section config, resumes from localStorage, creates the engine, mounts
   the view, wires persistence to the consultation API, analytics, the
   server-computed reveal, the mid-funnel email gate, the plan/review screens,
   and the handoff to the existing subscription checkout.

   PAYMONGO IS NOT TOUCHED. Checkout = assemble the existing
   `mcduffy_subscribe_config` shape + redirect to /pages/mcduffy-subscription,
   exactly as the legacy quiz does. The subscription page recomputes all prices
   server-side; our numbers are display-only.
   ============================================================================ */
(function () {
  'use strict';
  var DATA = window.MQ_DATA, ENGINE = window.MQ_Engine, VIEW = window.MQ_View, SCREENS = window.MQ_SCREENS;

  var rootEl = document.getElementById('mcduffy-quiz-v2-root');
  if (!rootEl || !DATA || !ENGINE || !VIEW) { return; }

  var cfg = {};
  try { cfg = JSON.parse(rootEl.getAttribute('data-config') || '{}'); } catch (e) { cfg = {}; }
  var BACKEND = (cfg.backendUrl || 'https://mcduffy-backend-production.up.railway.app').replace(/\/$/, '');
  var LS_KEY = 'mcduffy_quiz_v2';
  var SUB_KEY = 'mcduffy_subscribe_config';
  var POLICY_VERSION = cfg.policyVersion || '2026-06';

  /* ---------- restore session ---------- */
  var saved = null;
  try { saved = JSON.parse(localStorage.getItem(LS_KEY) || 'null'); } catch (e) {}
  var engine = ENGINE.createEngine({ sessionId: saved && saved.sessionId });
  if (saved && saved.dogs) { try { engine.hydrate(saved); } catch (e) {} }
  VIEW.useEngine(engine);
  try { window.MQ_ENGINE = engine; } catch (e) {} /* debug handle (read-only use); harmless in prod */

  /* Ad-campaign deep-link: ?preset=<key> swaps the welcome headline for
     message-match (ported from the live quiz at cutover). Re-read from the URL
     each load; valid keys only. The welcome builder reads engine.state.preset. */
  (function () {
    try {
      var p = (new URLSearchParams(location.search).get('preset') || '').toLowerCase().trim();
      if (p && (DATA.PRESETS || {})[p]) engine.state.preset = p;
      else if (saved && saved.preset && (DATA.PRESETS || {})[saved.preset]) engine.state.preset = saved.preset;
    } catch (e) {}
  })();

  var consultationId = (saved && saved.consultationId) || null;
  /* Built-plan state (server reveal + treats + recipe picks) is PERSISTED with the
     snapshot and restored here. Without this, resume rendered the plan from the
     hardcoded 7-bag fallback (server said 8) and handoff billed/shipped one bag
     short, and treats/recipe changes evaporated on reload. */
  var savedPlan = (saved && saved.planState) || {};
  var lastReveal = savedPlan.reveal || null;   /* cached server ResultBundle (restored on resume) */
  var lastCheckout = null;        /* checkout seed from /email */
  var treatCatalog = null;        /* /api/treats */
  var selectedTreats = Array.isArray(savedPlan.treats) ? savedPlan.treats : [];
  var recipeOverride = (savedPlan.recipeOverride && typeof savedPlan.recipeOverride === 'object') ? savedPlan.recipeOverride : {};        /* dogIndex -> recipe key chosen via "Change recipe" (auto-select stays default) */
  var handoffFired = false;       /* true once the user converts → suppress dropoff/overlays */
  var POUCH = window.MQ_POUCH;    /* personalized pouch renderer (assets/mcduffy-quiz-v2.pouch.js) */
  var POUCH_IMG = cfg.pouchImg || '';
  var emailCommitted = !!(saved && saved.emailCommitted); /* true once /email fired (don't re-fire CAPI on Back); survives reloads → "account saved" */
  /* false = returning subscriber who already used the 40% intro (server verdict
     from /email). Drop every 40%-off framing — checkout re-verifies and would
     charge full price, and the promise must never outrun the charge. */
  var introEligible = !(saved && saved.introEligible === false);
  function syncIntroClass() { try { rootEl.classList.toggle('mq-nointro', !introEligible); } catch (e) {} }
  syncIntroClass(); /* restore the member-pricing framing on resume */
  var EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  /* ---------- analytics ---------- */
  function track(name, payload) {
    payload = payload || {};
    payload.sessionId = engine.state.sessionId;
    if (consultationId) payload.consultationId = consultationId;
    if (engine.state.preset) payload.preset = engine.state.preset;
    try { if (window.McDuffyCommerceTrack) window.McDuffyCommerceTrack(name, payload); } catch (e) {}
    /* standard-event mirrors (Meta Pixel + GA4).
       NOTE: CompleteRegistration fires at the email gate (onReveal) with a shared
       event_id for CAPI dedup — deliberately NOT mirrored here. */
    try {
      if (name === 'quiz_start') { if (window.fbq) window.fbq('trackCustom', 'QuizStarted'); if (window.gtag) window.gtag('event', 'quiz_start'); }
      if (name === 'quiz_plan_view') { if (window.fbq) window.fbq('track', 'ViewContent', { value: payload.introPhp || 0, currency: 'PHP', content_type: 'product' }); if (window.gtag) window.gtag('event', 'view_item', { value: payload.introPhp || 0, currency: 'PHP' }); }
      if (name === 'quiz_checkout_intent') { if (window.fbq) window.fbq('track', 'InitiateCheckout', { value: payload.value || 0, currency: 'PHP' }); if (window.gtag) window.gtag('event', 'begin_checkout'); }
    } catch (e) {}
  }
  var crEventId = null;           /* shared CompleteRegistration event_id (client pixel + server CAPI dedup) */
  function newEventId() { try { if (window.crypto && crypto.randomUUID) return crypto.randomUUID(); } catch (e) {} return 'mq_' + Date.now().toString(36) + Math.random().toString(36).slice(2, 10); }

  /* ---------- persistence ---------- */
  var saveTimer = null;
  function persistLocal() {
    try { localStorage.setItem(LS_KEY, JSON.stringify(Object.assign(engine.snapshot(), { consultationId: consultationId, emailCommitted: emailCommitted, introEligible: introEligible, preset: engine.state.preset || null, planState: { reveal: lastReveal, treats: selectedTreats, recipeOverride: recipeOverride } }))); } catch (e) {}
  }
  function debouncedPersist() { clearTimeout(saveTimer); saveTimer = setTimeout(persistLocal, 250); }
  engine.subscribe(debouncedPersist);

  function api(method, path, body) {
    return fetch(BACKEND + path, {
      method: method, headers: { 'Content-Type': 'application/json' },
      body: body ? JSON.stringify(body) : undefined, keepalive: true
    }).then(function (r) { return r.ok ? r.json() : r.json().then(function (j) { throw Object.assign(new Error('http'), { status: r.status, body: j }); }, function () { throw new Error('http ' + r.status); }); });
  }

  function ensureConsultation() {
    if (consultationId) return Promise.resolve(consultationId);
    return api('POST', '/api/quiz/consultations', {
      schemaVersion: 'mcduffy-quiz-v1',
      attribution: trackingPayload().attribution, pageUrl: location.href, referrer: document.referrer
    }).then(function (r) { consultationId = r.consultationId; engine.state.consultationId = consultationId; persistLocal(); return consultationId; })
      .catch(function () { return null; });
  }

  /* ---- FE screen → backend stepId + per-dog answer ---- */
  var STEP_MAP = { dogname: 'dogName', sex: 'gender', age: 'age', neutered: 'neutered', breed: 'breed', weight: 'weight', sensitivities: 'healthConditions', goals: 'healthGoals', activity: 'activity', weightGoal: 'weightGoal', currentFood: 'currentFood' };
  var BREED_TYPE_MAP = { pure: 'pure-breed', mixed: 'cross-breed', unknown: 'not-sure' };

  function answerForDog(screenId, d) {
    switch (screenId) {
      case 'welcome': return d.name;
      case 'dogname': return d.name; /* mid-flow added dog — same backend dogName step */
      case 'sex': return d.sex;
      case 'age': return { years: d.ageYears, months: d.ageMonths || 0 };
      case 'neutered': return d.neutered;
      case 'breed': return { type: BREED_TYPE_MAP[d.breed.type] || 'not-sure', breeds: (d.breed.breeds || []).filter(Boolean).map(function (b) { return { id: b.id, label: b.label, size: b.size }; }) };
      case 'weight': return { value: engine.weightKg(d), unit: 'kg', estimated: !!d.weightEstimated };
      case 'sensitivities': return { selected: d.sensitivities || [], allergens: d.excludedAllergens || [], hypoallergenic: !!d.hypoallergenic };
      case 'goals': return d.healthGoals || [];
      case 'activity': return { tier: d.activityTier, workingDog: !!d.workingDog };
      case 'weightGoal': return d.weightGoal;
      case 'currentFood': return d.currentFood;
      default: return null;
    }
  }
  function stepReady(screenId) {
    var dogs = engine.state.dogs;
    function each(fn) { return dogs.every(fn); }
    switch (screenId) {
      case 'welcome': return each(function (d) { return d.name && d.name.trim(); });
      case 'dogname': return each(function (d) { return d.name && d.name.trim(); }); /* re-sends dogName with the added dog included */
      case 'sex': return each(function (d) { return d.sex === 'boy' || d.sex === 'girl'; });
      case 'age': return each(function (d) { return d.ageYears != null; });
      case 'neutered': return each(function (d) { return d.neutered === 'yes' || d.neutered === 'no'; }); /* skip if any 'unknown' */
      case 'breed': return each(function (d) { return engine.validate(engine.indexOfStep('breed', dogs.indexOf(d))).ok; });
      case 'weight': return each(function (d) { return engine.weightKg(d) != null; });
      case 'activity': return each(function (d) { return !!d.activityTier; });
      case 'weightGoal': return each(function (d) { return !!d.weightGoal; });
      case 'currentFood': return each(function (d) { return !!d.currentFood; });
      /* optional steps: always safe (validators accept defaults) */
      case 'sensitivities': case 'goals': return true;
      default: return false;
    }
  }
  function buildStepPayload(screenId) {
    var dogs = engine.state.dogs;
    if (dogs.length === 1) return { answer: answerForDog(screenId, dogs[0]) };
    return { answer: { dogs: dogs.map(function (d) { return answerForDog(screenId, d); }) } };
  }
  function patchStep(screenId) {
    var backendId = screenId === 'welcome' ? 'dogName' : STEP_MAP[screenId];
    if (!backendId) return Promise.resolve();
    if (!stepReady(screenId)) return Promise.resolve();
    return ensureConsultation().then(function (id) {
      if (!id) return;
      var payload = buildStepPayload(screenId);
      payload.phase = (SCREENS.BY_ID[screenId] || {}).chapter;
      return api('POST', '/api/quiz/consultations/' + id + '/answers/' + backendId, payload).catch(function () {});
    });
  }
  function syncAllSteps() {
    var ids = ['welcome', 'sex', 'age', 'neutered', 'breed', 'weight', 'sensitivities', 'goals', 'activity', 'weightGoal', 'currentFood'];
    return ids.reduce(function (chain, id) { return chain.then(function () { return patchStep(id); }); }, Promise.resolve());
  }

  function trackingPayload() {
    try { if (window.McDuffyAttribution && window.McDuffyAttribution.payload) return window.McDuffyAttribution.payload('quiz_v2'); } catch (e) {}
    return { attribution: {}, fbp: '', fbc: '', page_url: location.href, referrer: document.referrer };
  }

  /* ---------- lead capture at the mid-funnel contact step ---------- */
  function onContact(s) {
    var c = engine.state.contact;
    c.consentAt = new Date().toISOString();
    track('quiz_email_submit', { area: c.area });
    var tp = trackingPayload();
    /* existing lead-recovery surface (Viber follow-up) — best effort */
    api('POST', '/api/quiz-progress', {
      session_id: engine.state.sessionId, screen: 13, screen_id: 'contact', email: c.email,
      parent_name: engine.state.owner.name, parent_phone: c.phone || '',
      parent_viber_opt_in: !!c.viberOptIn, marketing_opt_in: !!c.marketingConsent,
      city: c.area || '', dog_name: (engine.state.dogs[0] || {}).name || '',
      attribution: tp.attribution, fbp: tp.fbp, fbc: tp.fbc
    }).catch(function () {});
    patchStep('welcome');
  }

  /* ---------- the reveal (server-computed grams/bags/₱) ---------- */
  function onReveal() {
    return ensureConsultation().then(function (id) {
      if (!id) return null;
      return syncAllSteps().then(function () {
        var c = engine.state.contact;
        var hasEmail = EMAIL_RE.test(c.email || '');
        /* fire the email gate (profile + CAPI CompleteRegistration) ONCE; on a
           later re-entry (e.g. Back from plan) recompute via /reveal only so CAPI
           doesn't double-fire. */
        if (hasEmail && !emailCommitted) {
          crEventId = newEventId();
          /* fire the browser CompleteRegistration WITH the shared event_id, at the same
             moment the server gate runs → CAPI + Pixel dedup (fixes the double-count) */
          try { if (window.fbq) window.fbq('track', 'CompleteRegistration', {}, { eventID: crEventId }); if (window.gtag) window.gtag('event', 'sign_up'); } catch (e) {}
          return api('POST', '/api/quiz/consultations/' + id + '/email', {
            email: c.email, marketingOptIn: !!c.marketingConsent, viberOptIn: !!c.viberOptIn, eventId: crEventId,
            consent: { dataPrivacyAccepted: true, policyVersion: POLICY_VERSION }
          }).then(function (r) { emailCommitted = true; if (r.reveal && r.reveal.introEligible === false) { introEligible = false; syncIntroClass(); } persistLocal(); syncAccountChip(); lastCheckout = r.checkout || null; return r.reveal; })
            .catch(function () { emailCommitted = true; /* fire CompleteRegistration at most once even if /email fails */ return api('POST', '/api/quiz/consultations/' + id + '/reveal', {}).then(function (r) { return r.reveal; }); });
        }
        return api('POST', '/api/quiz/consultations/' + id + '/reveal', {}).then(function (r) { return r.reveal; });
      });
    }).then(function (reveal) {
      if (!reveal) return null;
      onReveal._reminted = false; /* success clears the re-mint breaker */
      lastReveal = reveal;
      persistLocal(); /* the built plan must survive leave-and-return (resume showed 7 bags + no treats) */
      return toBundle(reveal);
    }).catch(function (err) {
      /* Expired/pruned consultation (30-day TTL) → every call 404s forever and the
         cached id was never re-minted: a PERMANENT silent dead-end (trace 2026-07-13).
         Re-mint once per attempt-cycle, resync all steps, and retry the reveal. */
      if (err && err.status === 404 && consultationId && !onReveal._reminted) {
        onReveal._reminted = true;
        consultationId = null;
        engine.state.consultationId = null;
        persistLocal();
        return onReveal();
      }
      throw err;
    });
  }
  function toBundle(reveal) {
    var perDog = (reveal.perDog || []).map(function (pd) {
      return { name: pd.name, gramsPerDay: pd.gramsPerDay, bagsPerMonth: pd.bagsPerMonth, recipeKey: pd.recipeKey, recipeLabel: pd.recipeLabel };
    });
    return {
      perDog: perDog, totalBags: reveal.totalBags,
      pricePerDayFromPhp: reveal.pricePerDayFrom != null ? reveal.pricePerDayFrom : (reveal.pricePerDayFromCentavos / 100),
      pricePerDayOngoingPhp: reveal.pricePerDayOngoing != null ? reveal.pricePerDayOngoing : (reveal.pricePerDayOngoingCentavos / 100),
      firstOrderPhp: (reveal.firstOrderTotalCentavos || 0) / 100,
      ongoingPhp: (reveal.recurringTotalCentavos || 0) / 100,
      /* 40/20/full ladder — the reveal ships it since 2026-07-06 (ramp live).
         Absent (env off / stale cached reveal) → render falls back to 50%/full. */
      cycleSchedule: reveal.cycleSchedule || null,
      introEligible: introEligible
    };
  }

  /* ---------- PLAN screen (variety-first: ≥3 recipes per dog) ---------- */
  var RECIPE_ORDER = DATA.RECIPE_ORDER || Object.keys(DATA.RECIPES || {});
  function recipeSafe(d, rk) { return !engine.recipeSafeForDog || engine.recipeSafeForDog(d, rk); }
  function recipesForDog(d, i, b) {
    if (recipeOverride[i] && recipeOverride[i].length) {
      /* re-filter saved picks — an age/allergy edit can outlaw an earlier choice */
      var kept = recipeOverride[i].filter(function (rk) { return recipeSafe(d, rk); });
      if (kept.length) return kept;
    }
    var pd = b && b.perDog[i];
    var mix = engine.recommendRecipes ? engine.recommendRecipes(d) : [engine.recommendRecipe(d)];
    /* keep the server's pick in the mix (first) when it isn't already there */
    if (pd && pd.recipeKey && mix.indexOf(pd.recipeKey) < 0 && recipeSafe(d, pd.recipeKey)) mix = [pd.recipeKey].concat(mix).slice(0, mix.length);
    return mix.length ? mix : ['chicken_rice'];
  }
  function recipeKeyForDog(d, i, b) { return recipesForDog(d, i, b)[0]; }
  function bagsForDog(i, b) { var pd = b && b.perDog[i]; return pd ? pd.bagsPerMonth : 7; }
  /* QLT-036 (real 4-dog customer: same build rendered 26 → 19 → 7 bags): a reveal
     is FRESH only when it covers every current dog. A failed/slow /reveal or an
     add-dog-after-reveal must NEVER silently render bagsForDog's 7-bag fallback
     as if it were the plan — gate every price render + the handoff on this. */
  function revealFresh() {
    /* every current dog must be present AND computed (>0 bags) — a dog whose
       answers went missing server-side computes 0 bags silently (trace path #3) */
    return !!(lastReveal && Array.isArray(lastReveal.perDog) &&
      lastReveal.perDog.length === engine.state.dogs.length &&
      lastReveal.perDog.every(function (pd) { return pd && Number(pd.bagsPerMonth) > 0; }));
  }
  /* split the dog's monthly bags across the mix: even split, remainder to the front */
  function splitBags(totalBags, recipes) {
    var n = Math.max(1, Math.min(recipes.length, totalBags || 1));
    var use = recipes.slice(0, n);
    var base = Math.floor(totalBags / n), rem = totalBags - base * n, out = {};
    use.forEach(function (rk, idx) { out[rk] = base + (idx < rem ? 1 : 0); });
    return out;
  }
  /* Subscription bulk benefit REMOVED 2026-07-14 (owner): recurring food is now
     FULL LIST price at every quantity — server SUBSCRIPTION_BULK_BENEFIT_TIERS is
     emptied in lockstep, so the plan/review quote has no bulk tier at any bag count. */
  function subTierMult(totalBags) { return 1; }
  function totalBagsAllDogs(b) {
    return engine.state.dogs.reduce(function (sum, d, i) { return sum + (bagsForDog(i, b) || 0); }, 0);
  }
  function dogPricePhp(d, i, b, mult) {
    var bags = splitBags(bagsForDog(i, b), recipesForDog(d, i, b)), sum = 0;
    mult = mult || 1;
    Object.keys(bags).forEach(function (rk) {
      var unit = Math.round(((DATA.RECIPES[rk] || {}).pricePerBagPhp || 259) * mult * 100) / 100;
      sum += bags[rk] * unit;
    });
    return sum;
  }
  /* display prices are computed from the mix client-side; the checkout re-quotes
     every peso server-side from the same recipeBags, so they stay in lockstep */
  function planPrices(b) {
    var mult = subTierMult(totalBagsAllDogs(b));
    var ongoing = engine.state.dogs.reduce(function (sum, d, i) { return sum + dogPricePhp(d, i, b, mult); }, 0);
    ongoing = Math.round(ongoing * 100) / 100;
    /* centavo-precise like the server (it bills Math.round(centavos*0.5) — showing
       ₱592 where checkout charges ₱591.50 read as a price change) */
    return { firstBox: Math.round(ongoing * 100 * (introEligible ? 0.5 : 1)) / 100, ongoing: ongoing };
  }
  function priceScheduleHTML(pp, b) {
    if (!introEligible) {
      /* returning subscriber — one honest number, no ladder */
      return '<div class="mq-price-block">' +
        '<div class="mq-price-row mq-price-row--hero"><span>Monthly total</span><span class="mq-price-now">' + peso(pp.ongoing) + '</span></div>' +
        '</div>';
    }
    var sched = b && b.cycleSchedule;
    var pct2 = (sched && sched.length >= 3) ? (Number(sched[1] && sched[1].discountPercent) || 0) : 0;
    if (pct2 > 0) {
      /* 3-tier ramp ON (server-confirmed via the reveal's cycleSchedule — live
         since 2026-07-06). Amounts are computed CLIENT-side from the live plan so
         recipe/bag edits re-price instantly; the server schedule supplies only the
         SIGNAL + PERCENT (its pesos are frozen at reveal time). Rounding matches
         billing: Math.round on centavos (webhook bills round(full × 0.8)). */
      var box2 = Math.round(pp.ongoing * 100 * (1 - pct2 / 100)) / 100;
      return '<div class="mq-price-block">' +
        '<div class="mq-price-row mq-price-row--hero"><span>First box · 40% off</span><span class="mq-price-now">' + peso(pp.firstBox) + '</span></div>' +
        '<details class="mq-price-detail"><summary>See your first 3 boxes</summary>' +
          '<div class="mq-price-row"><span>Box 2 · ' + pct2 + '% off</span><span>' + peso(box2) + '</span></div>' +
          '<div class="mq-price-row"><span>Box 3 onwards</span><span>' + peso(pp.ongoing) + '</span></div>' +
        '</details>' +
        '</div>';
    }
    /* No server cycleSchedule (env ramp off / stale cached reveal) → the safe
       two-tier: 40% first box, full after. The month-2 discount renders ONLY
       from a server-carried schedule — the promise must never outrun the charge. */
    return '<div class="mq-price-block">' +
      '<div class="mq-price-row mq-price-row--hero"><span>First box · 40% off</span><span class="mq-price-now">' + peso(pp.firstBox) + '</span></div>' +
      '<div class="mq-price-row mq-price-row--after"><span>Every box after</span><span class="mq-strike">' + peso(pp.ongoing) + '</span></div>' +
      '</div>';
  }
  function planDogCard(d, i, b) {
    var mix = recipesForDog(d, i, b);
    var primary = DATA.RECIPES[mix[0]] || {};
    var bags = bagsForDog(i, b);
    var bagSplit = splitBags(bags, mix);
    var fanN = Math.min(Object.keys(bagSplit).length, 3);
    var pouches = '';
    for (var p = 0; p < fanN; p++) pouches += POUCH.markup(POUCH_IMG, '-plan-' + i + '-' + p);
    var pouch = (POUCH && POUCH_IMG)
      ? (fanN > 1
        ? '<div class="mq-plan__fan mc-pouch-fan mc-pouch-fan--' + fanN + '">' + pouches + '</div>'
        : '<div class="mq-plan__pouch">' + pouches + '</div>')
      : '';
    var recipeLines = Object.keys(bagSplit).map(function (rk) {
      var r = DATA.RECIPES[rk] || {};
      return '<li>' + bagSplit[rk] + ' × ' + esc(r.label || rk) + '</li>';
    }).join('');
    var picker = RECIPE_ORDER.map(function (k) {
      var r = DATA.RECIPES[k]; if (!r) return '';
      var on = mix.indexOf(k) >= 0;
      var excluded = [].concat(d.excludedAllergens || [], d.avoidPreferences || []);
      var conflict = (r.allergens || []).filter(function (a) { return excluded.indexOf(a) >= 0; });
      var dogName = engine.tokens(i).Name || 'your dog';
      var blockNote = conflict.length
        ? 'Contains ' + conflict.join(', ') + ' — left out for ' + dogName
        : (r.adultOnly && engine.isPuppy && engine.isPuppy(d))
          ? 'For adult dogs (1 yr+) — ready when ' + dogName + ' grows up'
          : '';
      /* recipe detail POPUP trigger (info button is a SIBLING of the pick
         button — never nested — so it still works on blocked/disabled options).
         The modal itself is built on demand by openRecipeModal(). */
      var infoPanel = r.ingredients
        ? '<button type="button" class="mq-recipe-info" data-recipe-info="' + esc(k) + '" aria-haspopup="dialog" aria-label="About ' + esc(r.label) + '">' +
            '<svg viewBox="0 0 24 24" width="16" height="16" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="2"><circle cx="12" cy="12" r="9"/><path d="M12 11v5" stroke-linecap="round"/><circle cx="12" cy="7.5" r="1.2" fill="currentColor" stroke="none"/></svg>' +
          '</button>'
        : '';
      return '<div class="mq-recipe-row">' +
        '<button type="button" class="mq-recipe-opt' + (on ? ' is-selected' : '') + (blockNote ? ' is-blocked' : '') + '" data-pick-recipe="' + i + '" data-recipe="' + esc(k) + '"' + (blockNote ? ' disabled title="' + esc(conflict.length ? 'Contains ' + conflict.join(', ') : 'For adult dogs (1 yr+)') + '"' : '') + '>' +
        '<strong>' + esc(r.label) + '</strong><span class="mq-recipe-opt__tag">' + esc(blockNote || r.tagline || '') + '</span>' +
        '<span class="mq-recipe-opt__price">' + peso(r.pricePerBagPhp) + '/bag</span></button>' +
        infoPanel + '</div>';
    }).join('');
    var displayName = engine.tokens(i).Name || d.name || 'Your dog';
    return '<div class="mq-plan-card" data-dog-card="' + i + '">' + pouch +
      '<div class="mq-plan-card__head"><span class="mq-tier">' + esc(primary.tier || '') + '</span>' +
        '<h2>' + esc(displayName) + '</h2>' +
        '<p class="mq-plan-card__recipe">' + esc(Object.keys(bagSplit).map(function (rk) { return (DATA.RECIPES[rk] || {}).label || rk; }).join(' · ')) + '</p>' +
        (Object.keys(bagSplit).length > 1
          ? '<p class="mq-sub">A tastier month — variety keeps every mealtime exciting.</p>'
          : (primary.fishFree ? '<p class="mq-fishfree">' + esc(primary.tagline || '') + '</p>' : '<p class="mq-sub">' + esc(primary.tagline || '') + '</p>')) + '</div>' +
      '<ul class="mq-plan-card__mix">' + recipeLines + '</ul>' +
      '<p class="mq-plan-card__bags">' + bags + (bags === 1 ? ' bag' : ' bags') + ' a month in total</p>' +
      '<button type="button" class="mq-change-recipe" data-change-recipe="' + i + '" aria-expanded="false">Change recipes</button>' +
      '<div class="mq-recipe-picker" data-recipe-picker="' + i + '" hidden>' + picker + '</div>' +
      '<div class="mq-dog-actions">' +
        '<button type="button" class="mq-dog-edit" data-edit-dog="' + i + '">Edit ' + esc(displayName) + '</button>' +
        (engine.state.dogs.length > 1 ? '<button type="button" class="mq-dog-remove" data-remove-dog="' + i + '">Remove</button>' : '') +
      '</div>' +
      '</div>';
  }
  function paintPlanPouches(container, b) {
    if (!POUCH || !POUCH_IMG) return;
    engine.state.dogs.forEach(function (d, i) {
      var mix = recipesForDog(d, i, b), pd = b && b.perDog[i], grams = pd ? pd.gramsPerDay : 0, plan = POUCH.pickPlan(grams);
      for (var p = 0; p < Math.min(mix.length, 3); p++) {
        var root = container.querySelector('#mc-pouch-plan-' + i + '-' + p); if (!root) continue;
        POUCH.paint(root, { recipe: mix[p], dogName: d.name, dailyG: grams, packsPerDay: plan.packsPerDay, pouchSize: plan.pouchSize });
      }
    });
  }
  function renderPlanError(container) {
    container.innerHTML = '<div class="mq-plan mq-plan--loading" data-plan>' +
      '<div class="mq-plan-computing" role="alert">We couldn\u2019t finish computing the portions \u2014 nothing is wrong with your answers.' +
      '<br><button type="button" class="mq-confirm" data-retry-reveal style="margin-top:10px">Try again</button></div></div>';
    var rb = container.querySelector('[data-retry-reveal]');
    if (rb) rb.addEventListener('click', function () { renderPlanBody(container); });
  }

  function renderPlanBody(container) {
    /* QLT-036: never paint fallback numbers. Stale/absent reveal → honest
       computing state + auto-recompute; persistent failure → explicit retry. */
    if (!revealFresh()) {
      container.innerHTML = '<div class="mq-plan mq-plan--loading" data-plan>' +
        '<div class="mq-plan-computing" role="status">Crunching ' + (engine.state.dogs.length > 1 ? 'your pack\u2019s' : (esc(engine.tokens(0).Name || 'your dog') + '\u2019s')) + ' portions\u2026</div></div>';
      if (!renderPlanBody._busy) {
        renderPlanBody._busy = true;
        onReveal().then(function () {
          renderPlanBody._busy = false;
          if (revealFresh()) { renderPlanBody(container); }
          else { renderPlanError(container); }
        }, function () { renderPlanBody._busy = false; renderPlanError(container); });
      }
      return;
    }
    var b = toBundle(lastReveal);
    var pp = planPrices(b);
    container.innerHTML =
      '<div class="mq-plan" data-plan>' +
        engine.state.dogs.map(function (d, i) { return planDogCard(d, i, b); }).join('') +
        (engine.state.dogs.length < 10 ? '<button type="button" class="mq-add-dog" data-add-dog="1">+ Add another dog</button>' : '') +
        priceScheduleHTML(pp, b) +
        '<p class="mq-freetag">🏷️ ' + esc(DATA.COPY.freeTag) + '</p>' +
        '<p class="mq-risk">' + esc(DATA.COPY.riskReversal) + '</p>' +
      '</div>' +
      '<div class="mq-treats" data-treats hidden><h3>Add tasty extras</h3><div class="mq-treats__grid" data-treats-grid></div></div>' +
      stickyBar(pp.firstBox, pp.ongoing, 'Review order', 'to-review');
    paintPlanPouches(container, b);
    loadTreats(container);
  }
  function onPlan(container, s) {
    track('quiz_plan_view', { recipeId: lastReveal && lastReveal.recipeKey, introPhp: lastReveal && (lastReveal.firstOrderTotalCentavos / 100), ongoingPhp: lastReveal && (lastReveal.recurringTotalCentavos / 100) });
    /* delegated interactions attached once per mount (mirrors wireSticky) */
    container.addEventListener('click', function (e) {
      var info = e.target.closest('[data-recipe-info]');
      if (info) {
        var row = info.closest('.mq-recipe-row');
        openRecipeModal(info.getAttribute('data-recipe-info'), row ? row.querySelector('[data-pick-recipe]') : null, info);
        track('quiz_recipe_info_open', { recipe: info.getAttribute('data-recipe-info') });
        return;
      }
      var open = e.target.closest('[data-change-recipe]');
      if (open) {
        var picker = container.querySelector('[data-recipe-picker="' + open.getAttribute('data-change-recipe') + '"]');
        if (picker) { picker.hidden = !picker.hidden; open.setAttribute('aria-expanded', String(!picker.hidden)); }
        return;
      }
      var pick = e.target.closest('[data-pick-recipe]');
      if (pick && !pick.disabled) {
        var idx = parseInt(pick.getAttribute('data-pick-recipe'), 10), b = lastReveal ? toBundle(lastReveal) : null;
        var key = pick.getAttribute('data-recipe');
        var mix = recipesForDog(engine.state.dogs[idx], idx, b);
        var at = mix.indexOf(key);
        if (at >= 0) { if (mix.length > 1) mix.splice(at, 1); }       /* toggle off, never below 1 */
        else if (mix.length < 6) mix.push(key);                        /* toggle on — we RECOMMEND 3, but the full menu (6) is allowed; splitBags guards ≥1 bag per recipe */
        recipeOverride[idx] = mix;
        persistLocal(); /* recipe picks live outside engine state — persist or they vanish on resume */
        track('quiz_recipe_changed', { recipes: mix.join(','), dogIndex: idx });
        renderPlanBody(container);
        /* keep the picker open so they can keep tuning the mix */
        var reopened = container.querySelector('[data-recipe-picker="' + idx + '"]');
        var opener = container.querySelector('[data-change-recipe="' + idx + '"]');
        if (reopened) { reopened.hidden = false; if (opener) opener.setAttribute('aria-expanded', 'true'); }
        return;
      }
      var edit = e.target.closest('[data-edit-dog]');
      if (edit) { var ei = parseInt(edit.getAttribute('data-edit-dog'), 10); track('quiz_edit_dog', { dogIndex: ei }); engine.gotoScreen('sex', ei); return; }
      var add = e.target.closest('[data-add-dog]');
      if (add) { track('quiz_add_dog', { count: engine.state.dogs.length + 1 }); engine.addDog(); return; }
      var rem = e.target.closest('[data-remove-dog]');
      if (rem) {
        var ri = parseInt(rem.getAttribute('data-remove-dog'), 10);
        var shifted = {}; Object.keys(recipeOverride).forEach(function (k) { var ki = +k; if (ki === ri) return; shifted[ki > ri ? ki - 1 : ki] = recipeOverride[k]; });
        recipeOverride = shifted;
        engine.removeDog(ri); track('quiz_remove_dog', { dogIndex: ri });
        /* keep the cached reveal index-aligned with state.dogs IMMEDIATELY so a failed
           refetch can never render/bill a surviving dog against a removed dog's data */
        if (lastReveal && Array.isArray(lastReveal.perDog)) lastReveal.perDog.splice(ri, 1);
        renderPlanBody(container);
        onReveal().then(function () { renderPlanBody(container); }, function () {});
        return;
      }
    });
    wireSticky(container, s);
    renderPlanBody(container);
    /* resumed with no cached reveal (pre-planState snapshot) → recompute server-side,
       then repaint. The `if (b)` guard stops a null resolution from looping. */
    if (!lastReveal) onReveal().then(function (b) { if (b) renderPlanBody(container); }, function () {});
  }

  /* treat identity + peso helpers (shared with handoff/review) */
  function tkey(t) { return t.key || t.name || t.title; }
  function tpeso(t) { return (t.priceInPeso != null) ? t.priceInPeso : ((Number(t.price) || 0) / 100); }
  function dedupeTreats(items) {
    var seen = {}, out = [];
    (items || []).forEach(function (t) { var k = ((t.name || t.title || '') + '').toLowerCase() + '|' + tpeso(t); if (!seen[k]) { seen[k] = 1; out.push(t); } });
    return out;
  }
  function loadTreats(container) {
    var wrap = container.querySelector('[data-treats]');
    var grid = container.querySelector('[data-treats-grid]');
    if (!wrap || !grid) return;
    /* Display grouping + one-liners (owner-confirmed 2026-07-02). Unknown keys fall
       back to the API category so new catalog treats still render. */
    var TREAT_GROUP = { squash: 'freeze_dried', sweet_potato: 'freeze_dried', chicken_breast: 'freeze_dried', beef_liver: 'air_dried', pork_heart: 'air_dried', chicken_liver: 'freeze_dried', pork_liver: 'freeze_dried', yak_chews: 'chews', yak_chews_medium: 'chews', yak_chews_large: 'chews', yak_chews_extra_large: 'chews' };
    var GROUP_LABEL = { freeze_dried: 'Freeze-dried', air_dried: 'Air-dried', chews: 'Long-lasting chews', other: 'More treats' };
    var TREAT_DESC = {
      squash: 'Light, crisp squash — single ingredient, fiber-rich.',
      sweet_potato: 'Naturally sweet and gentle on tummies.',
      chicken_breast: 'Pure chicken breast — high-protein training treat.',
      beef_liver: 'Iron-rich beef liver, slow-dried whole.',
      pork_heart: 'Lean pork heart — naturally rich in taurine.',
      yak_chews: 'Hard Himalayan cheese chew for serious chewers.',
      yak_chews_medium: 'Hard Himalayan cheese chew for serious chewers.',
      yak_chews_large: 'Bigger chew for bigger jaws.',
      yak_chews_extra_large: 'The longest-lasting chew we make.'
    };
    function render(items) {
      if (!items || !items.length) return;
      treatCatalog = items;
      wrap.hidden = false;
      /* One "Add" button, added as a ONE-TIME first-box extra (2026-07-03 — the
         one-time/every-box choice was choice-paralysis after the core sale; the
         "make it every box" option now lives in the account portal). Name MUST
         match the AVAILABLE_TREATS catalog (checkout re-prices by name/key). */
      function cardHTML(t) {
        var sel = selectedTreats.filter(function (x) { return tkey(x) === tkey(t); })[0];
        var desc = t.description || TREAT_DESC[t.key] || '';
        return '<div class="mq-treat' + (sel ? ' is-on' : '') + '" data-treat="' + esc(tkey(t)) + '" data-testid="q-treat-' + esc(tkey(t)) + '">' +
          '<div class="mq-treat__head"><span class="mq-treat__name">' + esc(t.name || t.title) + '</span>' +
          '<span class="mq-treat__price">' + peso(tpeso(t)) + '</span></div>' +
          (desc ? '<p class="mq-treat__desc">' + esc(desc) + '</p>' : '') +
          '<div class="mq-treat__actions">' +
            '<button type="button" class="mq-treat__btn' + (sel ? ' is-active' : '') + '" data-treat-add="' + esc(tkey(t)) + '">' + (sel ? 'Added ✓' : 'Add to first box') + '</button>' +
          '</div></div>';
      }
      var groups = { freeze_dried: [], air_dried: [], chews: [], other: [] };
      items.forEach(function (t) {
        var g = TREAT_GROUP[t.key] || (groups[t.category] ? t.category : 'other');
        groups[g].push(t);
      });
      grid.innerHTML = ['freeze_dried', 'air_dried', 'chews', 'other'].map(function (g) {
        if (!groups[g].length) return '';
        return '<h4 class="mq-treats__group">' + esc(GROUP_LABEL[g]) + '</h4>' + groups[g].map(cardHTML).join('');
      }).join('');
      grid.onclick = function (e) {
        var btn = e.target.closest('[data-treat-add]'); if (!btn) return;
        var key = btn.getAttribute('data-treat-add');
        var item = items.filter(function (t) { return tkey(t) === key; })[0]; if (!item) return;
        var idx = selectedTreats.findIndex(function (x) { return tkey(x) === key; });
        if (idx >= 0) {
          selectedTreats.splice(idx, 1); track('quiz_treats_decision', { treatId: key, action: 'remove' });
        } else {
          /* one-time first-box extra; billing/recurring shape kept so the handoff
             + portal can still express recurring treats later */
          selectedTreats.push({ key: item.key, name: item.name || item.title, qty: 1, billing: 'one_time', recurring: false, billingLabel: 'First box only', price: tpeso(item), priceInPeso: tpeso(item) });
          track('quiz_treats_decision', { treatId: key, action: 'add', billing: 'one_time' });
        }
        persistLocal(); /* treats live outside engine state — persist or they vanish on resume */
        render(items);
      };
    }
    if (treatCatalog) { render(treatCatalog); return; }
    api('GET', '/api/treats').then(function (r) { render(dedupeTreats((r && (r.treats || r.items)) || (Array.isArray(r) ? r : []))); }).catch(function () {});
  }

  /* ---------- REVIEW screen ---------- */
  function treatsSum(list) { return list.reduce(function (x, t) { return x + (t.priceInPeso || t.price || 0) * (t.qty || 1); }, 0); }
  function onReview(container, s) {
    track('quiz_checkout_review_shown', { treatsCount: selectedTreats.length });
    /* QLT-036: the review is the last stop before billing — same freshness gate. */
    if (!revealFresh()) {
      container.innerHTML = '<div class="mq-plan mq-plan--loading"><div class="mq-plan-computing" role="status">Double-checking the totals\u2026</div></div>';
      if (!onReview._busy) {
        onReview._busy = true;
        onReveal().then(function () {
          onReview._busy = false;
          if (revealFresh()) { onReview(container, s); }
          else { renderPlanError(container); }
        }, function () { onReview._busy = false; renderPlanError(container); });
      }
      return;
    }
    var b = toBundle(lastReveal);
    var pp = planPrices(b);
    var treatsAll = treatsSum(selectedTreats);
    var treatsRecurring = treatsSum(selectedTreats.filter(function (t) { return t.recurring; }));
    var todayTotal = pp.firstBox + Math.round(treatsAll * 100 * (introEligible ? 0.5 : 1)) / 100;   /* intro 50% applies to first-box treats too; centavo-precise like the server bills */
    var ongoingTotal = pp.ongoing + treatsRecurring;
    var reviewTierMult = subTierMult(totalBagsAllDogs(b)); /* per-dog rows share the whole-order tier basis (server parity) */
    var uName = esc(engine.tokens(0).Name || (engine.state.dogs[0] || {}).name || 'your dog'); /* pre-purchase perk tease */
    var dogRows = engine.state.dogs.map(function (d, i) {
      var bagSplit = splitBags(bagsForDog(i, b), recipesForDog(d, i, b));
      var breakdown = Object.keys(bagSplit).map(function (rk) { return bagSplit[rk] + '× ' + ((DATA.RECIPES[rk] || {}).label || rk); }).join(' + ');
      return '<div class="mq-review__line"><span>' + esc(engine.tokens(i).Name || d.name || 'Your dog') + ' — ' + esc(breakdown) + '</span><span>' + peso(dogPricePhp(d, i, b, reviewTierMult)) + '</span></div>';
    }).join('');
    var treatRows = selectedTreats.map(function (t) {
      /* treats are one-time first-box extras — only tag the rare recurring one (portal-set) */
      var modeTag = t.recurring ? ' <em class="mq-review__mode">every box</em>' : '';
      return '<div class="mq-review__line"><span>' + esc(t.name) + modeTag + '</span><span>' + peso((t.priceInPeso || t.price || 0) * (t.qty || 1)) + '</span></div>';
    }).join('');
    var sched = b && b.cycleSchedule;
    var pct2r = (sched && sched.length >= 3) ? (Number(sched[1] && sched[1].discountPercent) || 0) : 0;
    /* ramp rows are computed from the TREATS-INCLUSIVE review totals — the server
       schedule's pesos are food-only and frozen at reveal time, so rendering them
       raw would contradict the "Total today" right above (audit 2026-07-06).
       Rounding parity: billing does Math.round(recurringCentavos × 0.8), and
       recurring treats ride that same recurring total. */
    var box2Total = pct2r > 0 ? Math.round(ongoingTotal * 100 * (1 - pct2r / 100)) / 100 : 0;
    var scheduleNote = !introEligible
      ? '<div class="mq-review__schedule">' +
          '<div><span>Every box</span><span>' + peso(ongoingTotal) + '</span></div>' +
        '</div>'
      : pct2r > 0
      ? '<div class="mq-review__schedule">' +
          '<div><span>Box 1 · 40% off</span><span>' + peso(todayTotal) + '</span></div>' +
          '<div><span>Box 2 · ' + pct2r + '% off</span><span>' + peso(box2Total) + '</span></div>' +
          '<div><span>Box 3 onwards</span><span>' + peso(ongoingTotal) + '</span></div>' +
        '</div>'
      : '<div class="mq-review__schedule">' +
          '<div><span>Box 1 · 40% off</span><span>' + peso(todayTotal) + '</span></div>' +
          '<div><span>Every box after</span><span>' + peso(ongoingTotal) + '</span></div>' +
        '</div>';
    container.innerHTML =
      '<div class="mq-review-card">' +
        '<div class="mq-review__banner">✓ ' + esc(introEligible ? (pct2r > 0 ? DATA.COPY.tierLine + ' · ' + pct2r + '% off your second' : DATA.COPY.tierLine) : 'Welcome back — member pricing on every box') + '</div>' +
        dogRows + treatRows +
        '<div class="mq-review__line mq-review__free"><span>🏷️ Free personalized dog tag</span><strong>FREE</strong></div>' +
        '<div class="mq-review__line"><span>Delivery</span><strong>Calculated at checkout</strong></div>' +
        '<div class="mq-toggle" role="tablist">' +
          '<button type="button" class="mq-toggle__tab is-active" data-toggle="first" role="tab" aria-selected="true">First box</button>' +
          '<button type="button" class="mq-toggle__tab" data-toggle="ongoing" role="tab" aria-selected="false">Ongoing</button>' +
        '</div>' +
        '<div class="mq-review__total" data-total><span>Total today</span><strong>' + peso(todayTotal) + '</strong></div>' +
        scheduleNote +
      '</div>' +
      '<div class="mq-nocommit">' +
        '<svg viewBox="0 0 24 24" width="26" height="26" aria-hidden="true"><path d="M9 12a3.5 3.5 0 013.5-3.5H15M15 12a3.5 3.5 0 01-3.5 3.5H9" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round"/><path d="M4 6l2 2M3 10h2.5M6 3l1.5 2.5M20 18l-2-2M21 14h-2.5M18 21l-1.5-2.5" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/></svg>' +
        '<div><strong>No commitment</strong><p>Pause your deliveries, move your dates, or cancel anytime.</p></div>' +
      '</div>' +
      '<div class="mq-unlocks">' +
        '<p class="mq-unlocks__h">The moment you order, ' + uName + ' unlocks</p>' +
        '<div class="mq-unlocks__grid">' +
          '<span class="mq-unlock"><b>✨ Virtual Care</b>an AI helper that knows ' + uName + '</span>' +
          '<span class="mq-unlock"><b>📄 Living Passport</b>vet-ready record, anytime</span>' +
          '<span class="mq-unlock"><b>🔔 Vaccine reminders</b>never miss a shot</span>' +
          '<span class="mq-unlock"><b>🏥 Vet handoff</b>a ready summary in a tap</span>' +
          '<span class="mq-unlock"><b>🎂 Birthday treat</b>free, in ' + uName + '’s box</span>' +
        '</div>' +
      '</div>' +
      stickyBar(todayTotal, pp.ongoing + treatsAll, 'Start first order', 'checkout'); /* strike = SAME basket pre-discount (food + all first-box treats), not the food-only ongoing */
    var totalEl = container.querySelector('[data-total]');
    container.querySelector('.mq-toggle').addEventListener('click', function (e) {
      var t = e.target.closest('[data-toggle]'); if (!t) return;
      container.querySelectorAll('.mq-toggle__tab').forEach(function (x) { x.classList.remove('is-active'); x.setAttribute('aria-selected', 'false'); });
      t.classList.add('is-active'); t.setAttribute('aria-selected', 'true');
      if (t.dataset.toggle === 'first') totalEl.innerHTML = '<span>Total today</span><strong>' + peso(todayTotal) + '</strong>';
      else totalEl.innerHTML = '<span>Every 30 days after</span><strong>' + peso(ongoingTotal) + '</strong>';
    });
    wireSticky(container, s);
    /* resumed with no cached reveal → recompute, then repaint totals. `if (b)` guard:
       a null resolution must not loop (recursion runs at most once — lastReveal is set
       before the recursive call; wireSticky is idempotent per container). */
    if (!lastReveal) onReveal().then(function (b) { if (b) onReview(container, s); }, function () {});
  }

  function stickyBar(firstBox, ongoing, ctaLabel, ctaAction) {
    var price = (ongoing != null && firstBox != null)
      ? (firstBox < ongoing
          ? '<span class="mq-sticky__old">' + peso(ongoing) + '</span> <span class="mq-sticky__now">' + peso(firstBox) + '</span>'
          : '<span class="mq-sticky__now">' + peso(ongoing) + '</span>') /* no discount → no fake strike-through */
      : '<span class="mq-sticky__now">Your first box</span>';
    return '<div class="mq-sticky-bar" role="region" aria-label="Order summary and checkout">' +
      '<div class="mq-sticky__price">' + price + '</div>' +
      '<button type="button" class="mq-sticky__cta" data-action="' + ctaAction + '" data-testid="q-' + ctaAction + '">' + esc(ctaLabel) + ' →</button></div>';
  }
  function wireSticky(container, s) {
    document.body.classList.add('mq-has-sticky');
    /* idempotent per container — the resume-recompute path re-renders into the SAME
       container node; a second listener would double-fire handoff()/InitiateCheckout */
    if (container.__mqStickyWired) return;
    container.__mqStickyWired = true;
    container.addEventListener('click', function (e) {
      var a = e.target.closest('[data-action]'); if (!a) return;
      if (a.dataset.action === 'to-review') engine.next();
      else if (a.dataset.action === 'checkout') { track('quiz_checkout_intent', {}); handoff(); }
    });
  }

  /* ---------- recipe detail modal (opened from the ⓘ on plan-screen pickers).
     Appended to document.body — NOT the screen — because .mq-screen carries
     will-change:transform, which traps position:fixed (the sticky-bar gotcha). */
  function openRecipeModal(key, pickBtn, trigger) {
    var r = DATA.RECIPES[key]; if (!r) return;
    closeRecipeModal();
    var badges = [];
    if (r.fishFree) badges.push('🚫 No fish');
    if ((r.allergens || []).length === 1) badges.push('Single protein');
    if (r.adultOnly) badges.push('Adult dogs (1 yr+)');
    badges.push('500g recipe');
    var canPick = pickBtn && !pickBtn.disabled;
    var blocked = pickBtn && pickBtn.disabled ? (pickBtn.getAttribute('title') || 'Not available for this dog') : '';
    var ov = document.createElement('div');
    ov.className = 'mq-rmodal';
    ov.innerHTML =
      '<div class="mq-rmodal__scrim" data-rm-close></div>' +
      '<div class="mq-rmodal__card" role="dialog" aria-modal="true" aria-label="About ' + esc(r.label) + '">' +
        '<button type="button" class="mq-rmodal__x" data-rm-close aria-label="Close">✕</button>' +
        '<p class="mq-rmodal__tier">500g recipe · ' + peso(r.pricePerBagPhp) + '/bag</p>' +
        '<h3 class="mq-rmodal__name">' + esc(r.label) + '</h3>' +
        '<p class="mq-rmodal__tag">' + esc(r.tagline || '') + '</p>' +
        '<div class="mq-rmodal__badges">' + badges.map(function (b) { return '<span>' + esc(b) + '</span>'; }).join('') + '</div>' +
        ((r.benefits || []).length ? '<ul class="mq-rmodal__benefits">' + r.benefits.map(function (b) { return '<li>' + esc(b) + '</li>'; }).join('') + '</ul>' : '') +
        '<p class="mq-rmodal__ingr"><strong>Ingredients:</strong> ' + esc(r.ingredients || '') + '</p>' +
        (r.kcalPerKg ? '<p class="mq-rmodal__kcal">' + Number(r.kcalPerKg).toLocaleString('en-PH') + ' kcal per kg</p>' : '') +
        (blocked ? '<p class="mq-rmodal__blocked">' + esc(blocked) + '</p>' : '') +
        (canPick ? '<button type="button" class="mq-rmodal__cta" data-rm-pick>Choose ' + esc(r.label) + '</button>' : '') +
      '</div>';
    document.body.appendChild(ov);
    document.body.classList.add('mq-rmodal-open');
    ov.addEventListener('click', function (e) {
      if (e.target.closest('[data-rm-close]')) { closeRecipeModal(trigger); return; }
      if (e.target.closest('[data-rm-pick]')) { closeRecipeModal(); try { pickBtn.click(); } catch (er) {} }
    });
    ov._esc = function (e) { if (e.key === 'Escape') closeRecipeModal(trigger); };
    document.addEventListener('keydown', ov._esc);
    setTimeout(function () { ov.classList.add('is-in'); var x = ov.querySelector('.mq-rmodal__x'); if (x) { try { x.focus(); } catch (er) {} } }, 20);
  }
  function closeRecipeModal(refocus) {
    var ov = document.querySelector('.mq-rmodal'); if (!ov) return;
    document.removeEventListener('keydown', ov._esc);
    document.body.classList.remove('mq-rmodal-open');
    ov.remove();
    if (refocus) { try { refocus.focus(); } catch (e) {} }
  }

  /* ---------- HANDOFF — build the legacy-compatible config, redirect ---------- */
  function handoff() {
    // QLT-028: never hand off to checkout on a failed/absent server reveal — that would
    // ship a degenerate 7-bag / 0g fallback plan (bagsForDog defaults to 7, grams to 0).
    // Retry the reveal; only proceed once it truly resolves. This retry usually clears a
    // transient failure seamlessly; a persistent failure keeps the user on the plan
    // screen with an announcement instead of billing a bogus plan.
    if (!revealFresh()) { /* QLT-036: stale (dog-count mismatch) is as dangerous as absent */
      /* the .mq-live region is visually hidden (a11y-only) — the CTA looked DEAD on
         failure (trace 2026-07-13). Show a VISIBLE banner too. */
      var announce = function (msg, working) {
        var live = document.querySelector('.mq-live');
        if (live) { live.textContent = msg; }
        var bar = document.querySelector('.mq-plan-alert');
        if (!bar) {
          bar = document.createElement('div');
          bar.className = 'mq-plan-alert';
          bar.setAttribute('role', 'alert');
          var host = document.querySelector('[data-plan]') || document.querySelector('.mq-screen[data-state="active"]') || document.body;
          host.insertBefore(bar, host.firstChild);
        }
        bar.textContent = msg;
        bar.classList.toggle('is-working', !!working);
      };
      announce('Finishing your plan…', true);
      onReveal().then(function (b2) {
        if (b2 && revealFresh()) {
          var bar = document.querySelector('.mq-plan-alert'); if (bar) bar.remove();
          handoff();
        }
        else { announce('We couldn’t finish computing your plan — tap “Start first order” to retry, or check your connection.'); }
      }, function () {
        announce('We couldn’t reach our kitchen to finish your plan. Check your connection and tap “Start first order” again.');
      });
      return;
    }
    handoffFired = true;
    document.body.classList.remove('mq-has-sticky');
    var b = lastReveal ? toBundle(lastReveal) : null;
    var st = engine.state, tp = trackingPayload();
    var dogsCfg = st.dogs.map(function (d, i) {
      var pd = b && b.perDog[i];
      var mix = recipesForDog(d, i, b);
      var recipeKey = mix[0];
      var bags = pd ? pd.bagsPerMonth : 7;
      var perBag = (DATA.RECIPES[recipeKey] || {}).pricePerBagPhp || 259;
      var recipeBags = splitBags(bags, mix);
      var grams = pd ? pd.gramsPerDay : 0;
      var recipeGrams = {}; Object.keys(recipeBags).forEach(function (rk) { recipeGrams[rk] = grams; });
      var plan = (POUCH && POUCH.pickPlan) ? POUCH.pickPlan(grams) : { pouchSize: 500, packsPerDay: 1 };
      /* true age: months when the dog is under a year (order note + CAPI read this) */
      var ageVal = (d.ageYears || 0), ageUnit = 'years';
      if (!d.ageYears && d.ageMonths) { ageVal = d.ageMonths; ageUnit = 'months'; }
      return {
        name: d.name,
        dogProfile: {
          name: d.name, breed: engine.breedLabel(d), age: ageVal, ageUnit: ageUnit,
          sex: d.sex || '', neutered: d.neutered || '', weight: engine.weightKg(d),
          condition: (DATA.WEIGHT_GOALS.filter(function (x) { return x.value === d.weightGoal; })[0] || {}).condition || 'ideal',
          activity: (DATA.ACTIVITY_TIERS.filter(function (x) { return x.value === d.activityTier; })[0] || {}).calc || 'moderate',
          currentFoodType: d.currentFood || '', currentFoodBrand: d.currentBrand || '',
          healthIssues: d.sensitivities || [], allergyIngredients: d.excludedAllergens || []
        },
        recipe: recipeKey, recipes: Object.keys(recipeBags), recipeBags: recipeBags, recipeGrams: recipeGrams,
        qty: bags, perBag: perBag,
        total: Object.keys(recipeBags).reduce(function (s2, rk) { return s2 + recipeBags[rk] * ((DATA.RECIPES[rk] || {}).pricePerBagPhp || 259); }, 0),
        weight: engine.weightKg(d), dailyGrams: grams, fullDailyGrams: pd ? (pd.fullDailyGrams || grams) : grams,
        pouchSize: plan.pouchSize, packsPerDay: plan.packsPerDay
      };
    });
    var totalQty = dogsCfg.reduce(function (s2, d) { return s2 + (d.qty || 0); }, 0);
    var config = {
      dogs: dogsCfg,
      recipe: dogsCfg[0].recipe, qty: totalQty, plan: 'full',
      dogProfile: dogsCfg[0].dogProfile,
      perBag: dogsCfg[0].perBag, total: dogsCfg.reduce(function (s2, d) { return s2 + d.total; }, 0),
      frequency: 'monthly',
      treats: selectedTreats,
      source: 'quiz', session_id: st.sessionId, sessionId: st.sessionId,
      consultationId: consultationId,
      conviction: st.belief || '', priority: '',
      allergyIngredients: st.dogs[0].excludedAllergens || [],
      allergy_ingredients: st.dogs[0].excludedAllergens || [],
      parentName: st.owner.name || '', parentEmail: st.contact.email || '', parentPhone: st.contact.phone || '',
      parentEmailOptIn: !!st.contact.marketingConsent, parentViberOptIn: !!st.contact.viberOptIn,
      email: st.contact.email || '',
      quizPreset: engine.state.preset || '', attribution: tp.attribution, fbp: tp.fbp, fbc: tp.fbc,
      pageUrl: location.href, referrer: document.referrer,
      eventIds: crEventId ? { complete_registration: crEventId } : {}
    };
    config.dogProfile.parentName = config.parentName;
    config.dogProfile.parentEmail = config.parentEmail;
    config.dogProfile.parentPhone = config.parentPhone;
    config.estimatedFirstOrder = b ? b.firstOrderPhp : config.total;
    config.estimatedRecurring = b ? b.ongoingPhp : config.total;
    config.estimatedTreatsRecurring = selectedTreats.filter(function (t) { return t.recurring; }).reduce(function (s2, t) { return s2 + (t.priceInPeso || t.price || 0) * (t.qty || 1); }, 0);
    config.estimatedTreatsOneTime = selectedTreats.filter(function (t) { return !t.recurring; }).reduce(function (s2, t) { return s2 + (t.priceInPeso || t.price || 0) * (t.qty || 1); }, 0);
    /* Carry the server's intro verdict to checkout. Without it, a returning
       subscriber (introEligible=false) sees a 40%-off flash on the subscription
       page until the /quote round-trip corrects it — the promise must never
       outrun the charge. isNoIntroMode() reads these exact keys. */
    config.introEligible = introEligible;
    if (!introEligible) { config.billingMode = 'full'; config.forceFullPrice = true; }
    try { localStorage.setItem(SUB_KEY, JSON.stringify(config)); } catch (e) {}
    /* cfg.checkoutUrl lets the offline preview harness route to its local checkout
       page; unset in production → the live Shopify checkout as always */
    window.location.href = cfg.checkoutUrl || '/pages/mcduffy-subscription';
  }

  /* ---------- helpers ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function peso(n) {
    /* centavo-precise: the server bills exact halves (₱900.50) — rounding the display
       to ₱901 reads as a price change at checkout. Whole amounts stay clean (₱1,352). */
    var v = Math.round((Number(n) || 0) * 100) / 100;
    return '₱' + v.toLocaleString('en-PH', { minimumFractionDigits: (v % 1 ? 2 : 0), maximumFractionDigits: 2 });
  }

  /* ---------- saved-account chip (tails-style "Log out" once the email gate fires) ---------- */
  function syncAccountChip() {
    var bar = document.querySelector('.mq-topbar'); if (!bar) return;
    var chip = bar.querySelector('.mq-account-chip');
    var email = (engine.state.contact && engine.state.contact.email) || '';
    if (!emailCommitted || !email) { if (chip) chip.remove(); return; }
    if (!chip) {
      chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'mq-account-chip';
      chip.addEventListener('click', function () {
        track('quiz_logout', {});
        try { localStorage.removeItem(LS_KEY); } catch (e) {}
        window.location.reload();
      });
      bar.appendChild(chip);
    }
    chip.innerHTML = '<span class="mq-account-chip__who">' + esc(email) + '</span><span class="mq-account-chip__cta">Log out</span>';
    chip.title = 'Saved as ' + email + ' — log out to start over';
  }

  /* ---------- mount ---------- */
  VIEW.mountView(rootEl, engine, {
    track: track,
    onProgress: function () {},
    onStepComplete: function (step) { if (step && step.screenId) patchStep(step.screenId); },
    onContact: onContact,
    onReveal: onReveal,
    onPlan: onPlan,
    onReview: onReview
  });

  /* recovery overlays (objection capture + exit-intent + popup suppressor + dropoff) */
  try {
    if (window.MQ_Overlays) window.MQ_Overlays.init(rootEl, {
      track: track,
      getScreen: function () { return (engine.currentStep() || {}).screenId || ''; },
      getDogName: function () { return ((engine.tokens && engine.tokens(0)) || {}).Name || 'your dog'; },
      isDone: function () { return handoffFired; }
    });
  } catch (e) {}

  /* returning visitor with a saved plan → show the account chip immediately */
  syncAccountChip();

  /* create the consultation in the background on first load */
  ensureConsultation();
})();
